// types
import { ICampus } from './types'
// components
import { useGetRelationsOutByIdQuery } from '../../../../services/objects';
import { LoadingView } from '../../../../components';
import { AutomationObjectsFlexGridView } from '../../../components/Grid/AutomationObjectsFlexGridView';

function OperatorPanel(props: ICampus) {

    const { data, isLoading, error, isSuccess } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: 'Contains'})

    return (
        <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
            {data && <AutomationObjectsFlexGridView items={data}></AutomationObjectsFlexGridView>}
        </LoadingView>
    );
}

export default OperatorPanel
